<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-left">
        <div
          v-show="stateArrow"
          id="leftBox"
          class="leftBox"
          style="width: 206px"
        >
          <vue-draggable-resizable
            :min-width="160"
            @resizing="onResize"
            :max-width="400"
            :draggable="false"
            :handles="['mr']"
            :w="206"
            :parent="false"
          >
            <el-scrollbar>
              <tree
                :isSearch="isSearch"
                @initFun="initQuery"
                @nodeClick="nodeClick"
              ></tree>
            </el-scrollbar>
          </vue-draggable-resizable>
        </div>
        <div class="leftCaret" @click="changeArrow">
          <i
            :class="stateArrow ? 'el-icon-caret-left' : 'el-icon-caret-right'"
          ></i>
        </div>
      </div>
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane :label="$t('SafeManagement.TabRemind')" name="first">
                <div v-if="'first' === activeName">
                    <CheckRemind ref='TabRemind'></CheckRemind>
                </div>
                
              </el-tab-pane>
              <el-tab-pane :label="$t('SafeManagement.TabAnalysis')" name="second">
                <div v-if="'second' === activeName">
                    <CheckAnalysis ref="TabAnalysis"></CheckAnalysis>
                </div>
                
              </el-tab-pane>
              <el-tab-pane :label="$t('SafeManagement.TabReportForm')" name="third">
                <div v-if="'third' === activeName">
                    <CheckReportForm ref="TabReportForm"></CheckReportForm>
                </div>
                
              </el-tab-pane>
            </el-tabs>
          </el-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CarCheck from "./CarCheck.js";
export default CarCheck;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
</style>
